/**
 * FX3 — per-org deploy-branch resolution (client mirror).
 *
 * Mirrors the backend rule in apps/stride-api/src/connections/deployBranch.ts
 * so the Compare footer can show the target org branch before the deploy runs.
 * Keep the two in lockstep — the backend is the source of truth.
 */

/** Lowercase + collapse any run of non-alphanumerics to a single '-', trimmed. */
export function slug(input: string): string {
  return input
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
}

/**
 * Resolve the long-lived deploy branch for a connection.
 * Honours an explicit `deployBranch`; otherwise defaults to `org/<label-slug>`.
 */
export function resolveDeployBranch(conn: { label: string; deployBranch?: string }): string {
  return conn.deployBranch ?? `org/${slug(conn.label)}`
}
